import React, { useState } from "react";
import { Tabs } from "../../_styleguide";
import { IconReport } from "@tabler/icons-react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Header, Text } from "@centrate-io/barn";
import "./SecuredWorkflow.scss";
import SecuredWorkflowTable from "./_components/SecuredWorkflowTable/SecuredWorkflowTable";

function SecuredWorkflow(props) {
    const navigate = useNavigate();
    const params = useParams();
    const [tab, setTab] = useState(params?.tab) || "sample-tab";
    const deal_id = params.id;
  
    let items = [
      {
        key: "sample-table",
        label: (
          <div className="tab-name">
            <IconReport />
            Sample Table
          </div>
        ),
        children: <SecuredWorkflowTable/>,
      },
      {
        key: "sample-tab-2",
        label: (
          <div className="tab-name">
            <IconReport />
            Sample Tab
          </div>
        ),
        children: <></>,
      }
    ];
  
    return (
      <div className="admin-tabs app-secured-workflow">
        <div className="admin-header">
          <div className="crumbs" >
            <Header type="display" size="5">
              Secured Workflow
            </Header>
          </div>
        </div>
        <Tabs
          onChange={(key) => {
            navigate(`/deal/${deal_id}/secured-workflow/${key}`);
            setTab(key);
          }}
          activeKey={tab}
          items={items}
          className={tab}
          destroyInactiveTabPane={true}
        />
      </div>
    );
  }
  
  export default SecuredWorkflow;